import { useNavigate } from 'react-router-dom'

/**
 * Reusable DrillDownLink for Calendar events (Job, Project, Task, Leave)
 */
export default function DrillDownLink({ icon, label, to, returnTo }) {
  const navigate = useNavigate()

  if (!to) return null

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation()
        navigate(to, {
          state: { returnTo: returnTo || window.location.pathname },
        })
      }}
      className="inline-flex items-center gap-1.5 rounded-md border border-outline-variant/40 bg-surface-container px-2.5 py-1 text-xs font-semibold text-primary transition-all hover:bg-primary/10 hover:border-primary/40 focus:outline-none focus:ring-1 focus:ring-primary shadow-xs"
    >
      {icon ? <span className="material-symbols-outlined text-[13px]">{icon}</span> : null}
      <span className="truncate max-w-[180px]">{label}</span>
      <span className="material-symbols-outlined text-[11px] opacity-70">open_in_new</span>
    </button>
  )
}
